export default function ModuloTerrenoPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold text-gray-800">Módulo Terreno</h1>
        <p className="text-sm text-gray-500 mt-0.5">Este perfil está habilitado para la app móvil de lecturas.</p>
      </div>

      <div className="rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-800">
        El rol <strong>Lector de Terreno</strong> no opera en el panel administrativo web.
        Usa la aplicación móvil para sincronizar rutas y registrar lecturas.
      </div>
    </div>
  );
}
